const termsPrefix = '/api/terms';
const membersPrefix = '/api/members';

export const termsPaths = {
  currentActivated: `${termsPrefix}/current-activated`,
  acceptTerms: `${membersPrefix}/terms/accept`,
  acceptStatus: `${membersPrefix}/terms/accept`,
  // TRAD-3759 — backend TRAD-3756(W1)
  requiredMissing: `${membersPrefix}/terms/required-missing`,
  acceptBatch: `${membersPrefix}/terms/accept-batch`,
  // TRAD-3759 — 로그인 전 가입 화면용 «필수 항목 + 지금 버전»(backend 공개 엔드포인트, required-missing 과 같은 items 모양)
  required: `${termsPrefix}/required`,
} as const;
